<svelte:options immutable={true} />

<script>
    import { createEventDispatcher } from "svelte";
    import Toolbar from "./Toolbar.svelte";

    export let selectedCount = 0;
    export let hasGrouped = false;

    const dispatch = createEventDispatcher();
</script>

{#if selectedCount > 1 || hasGrouped}
    <Toolbar>
        <div class="flex items-center gap-0.5 px-1">
            {#if hasGrouped}
                <button
                    on:click={() => dispatch("ungroup")}
                    class="w-8 h-8 md:w-9 md:h-9 flex flex-col items-center justify-center btn-hover rounded-xl transition-colors"
                    title="Ungroup"
                >
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        class="text-indigo-600"
                    >
                        <path
                            d="M8 8v8H4V8h4m6 0v8h-4V8h4m-6 8v4H4v-4h4m6 0v4h-4v-4h4"
                        />
                        <rect
                            x="2"
                            y="2"
                            width="20"
                            height="20"
                            stroke-width="2"
                            stroke-dasharray="4 4"
                            rx="2"
                        />
                    </svg>
                </button>
            {/if}
            {#if selectedCount > 1 && !hasGrouped}
                <button
                    on:click={() => dispatch("group")}
                    class="w-8 h-8 md:w-9 md:h-9 flex flex-col items-center justify-center btn-hover rounded-xl transition-colors"
                    title="Group"
                >
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        class="text-indigo-600"
                        stroke="currentColor"
                        stroke-width="2"
                    >
                        <rect
                            x="4"
                            y="4"
                            width="16"
                            height="16"
                            rx="2"
                            ry="2"
                        />
                        <line x1="12" y1="4" x2="12" y2="20" />
                        <line x1="4" y1="12" x2="20" y2="12" />
                    </svg>
                </button>
            {/if}

            {#if selectedCount > 1}
                <div class="w-px h-5 bg-gray-200/80 mx-1"></div>
                <button
                    on:click={() => dispatch("align", "left")}
                    class="w-8 h-8 md:w-9 md:h-9 flex flex-col items-center justify-center btn-hover rounded-xl transition-colors"
                    title="Align Left"
                >
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        class="text-gray-700 opacity-80"
                    >
                        <path d="M2 4v16M6 8h10M6 16h6M10 8v8M18 8v4" />
                    </svg>
                </button>
                <button
                    on:click={() => dispatch("align", "centerH")}
                    class="w-8 h-8 md:w-9 md:h-9 flex flex-col items-center justify-center btn-hover rounded-xl transition-colors"
                    title="Align Center Horizontal"
                >
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        class="text-gray-700 opacity-80"
                    >
                        <path d="M12 2v20M8 6h8M6 14h12M10 10h4M9 18h6" />
                    </svg>
                </button>
                <button
                    on:click={() => dispatch("align", "right")}
                    class="w-8 h-8 md:w-9 md:h-9 flex flex-col items-center justify-center btn-hover rounded-xl transition-colors"
                    title="Align Right"
                >
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        class="text-gray-700 opacity-80"
                    >
                        <path d="M20 22V2M16 6H6M16 14h-6M16 10H8M16 18h-4" />
                    </svg>
                </button>
                <button
                    on:click={() => dispatch("align", "top")}
                    class="w-8 h-8 md:w-9 md:h-9 flex flex-col items-center justify-center btn-hover rounded-xl transition-colors"
                    title="Align Top"
                >
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        class="text-gray-700 opacity-80"
                    >
                        <path d="M22 4H2M6 8v10M14 8v6M10 8v8M18 8v4" />
                    </svg>
                </button>
                <button
                    on:click={() => dispatch("align", "centerV")}
                    class="w-8 h-8 md:w-9 md:h-9 flex flex-col items-center justify-center btn-hover rounded-xl transition-colors"
                    title="Align Center Vertical"
                >
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        class="text-gray-700 opacity-80"
                    >
                        <path d="M2 12h20M6 8v8M14 6v12M10 10v4M18 9v6" />
                    </svg>
                </button>
                <button
                    on:click={() => dispatch("align", "bottom")}
                    class="w-8 h-8 md:w-9 md:h-9 flex flex-col items-center justify-center btn-hover rounded-xl transition-colors"
                    title="Align Bottom"
                >
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        class="text-gray-700 opacity-80"
                    >
                        <path d="M22 20H2M6 16V6M14 16v-6M10 16V8M18 16v-4" />
                    </svg>
                </button>
            {/if}
        </div>
    </Toolbar>
{/if}
